import { CircularProgress } from '@mui/material';
import AppAdminTable from 'components/AppAdminTable/AppAdminTable';
import ListPage from 'components/ListPage/ListPage';
import Pagination from 'components/Pagination/Pagination';
import { TableColumns } from 'helpers/tableColumns';
import { useRemoteResource } from 'hooks/useRemoteResource';
import supportSAService from 'services/superadmin/supportSAService';

const listConfig = [
    {
        key: "order",
        label: "#",
        render: (v, i) => i + 1
    },
    {
        key: 'title',
        label: 'Тема'
    },
    {
        key: 'name',
        label: 'Имя'
    },
    {
        key: 'email',
        label: 'Email'
    },
    {
        key: "text",
        label: "Сообщение",
    },
    TableColumns.createdDate,
]

export const SupportList = () => {
    const [data, loadData, loading] = useRemoteResource(supportSAService.getAll, "");

    const onDelete = async (u) => {
        await supportSAService.delete(u.id);
        loadData();
    };

    if (loading) {
        return <div className="text-center"><CircularProgress></CircularProgress></div>
    }

    return (
        <ListPage pageTitle="Служба поддержки">
            <AppAdminTable
                columnConfig={listConfig}
                data={data?.data || []}
                onDelete={onDelete}
                loading={loading}
            />
            {data && <Pagination total={data.total} limit={50} />}
        </ListPage>
    );
}
